import Card from "@pathwright/ui/src/components/card/Card"
import CardBack from "@pathwright/ui/src/components/card/CardBack"
import Screensize, {
  useScreensizeContext
} from "@pathwright/ui/src/components/ui/Screensize"
import PropTypes from "prop-types"
import styled from "styled-components"
import ResourceContainer from "../store/resource/ResourceContainer"

const StyledCard = styled(Card)`
  padding: 0 !important;
  &:last-child {
    min-height: 100vh;
  }
`

function BelltowerResourceCard(props) {
  const { card, id, schoolId, structure, browseTo, onLicense } = props
  const screensize = useScreensizeContext()
  return (
    <StyledCard
      card={card}
      navless
      rounded={screensize !== "sm"}
      style={screensize !== "sm" ? { overflow: "hidden" } : {}}
    >
      <Screensize.Consumer>
        {({ screensize }) => (
          <Screensize.Provider screensize={screensize === "sm" ? "sm" : "md"}>
            <ResourceContainer
              id={id}
              schoolId={schoolId}
              structure={structure}
              onLicense={onLicense}
              browseTo={browseTo}
            />
          </Screensize.Provider>
        )}
      </Screensize.Consumer>
      <CardBack card={card} backLabel="Browse" inverted />
    </StyledCard>
  )
}

BelltowerResourceCard.displayName = "BelltowerResourceCard"

BelltowerResourceCard.propTypes = {
  card: PropTypes.object.isRequired,
  id: PropTypes.number.isRequired,
  schoolId: PropTypes.number.isRequired,
  browseTo: PropTypes.func.isRequired,
  onLicense: PropTypes.func.isRequired
}

BelltowerResourceCard.defaultProps = {
  structure: [
    "ResourceHeader",
    "ResourcePreview",
    "ResourceDescription",
    "ResourceAuthors",
    "ResourcePublisher",
    "ResourceOfferings",
    "ResourceRelated"
  ]
}

export default BelltowerResourceCard
